module.exports = __webpack_public_path__ + "static/Bild Seite 3 - Verkäuferin-3885b3d5e12f267521b0c3692c94eb9b.jpg";